export default {
  LINKS: {
    GITHUB_LINK: 'https://github.com/TonyBosshardt',
    LINKEDIN_LINK: 'https://www.linkedin.com/in/anthony-bosshardt-md-a78b46123',
    RESUME_LINK: 'https://s3.us-east-2.amazonaws.com/abosshardt.com/resume.pdf',
    BLACK_SHOLES_LINK: 'https://en.wikipedia.org/wiki/Binomial_options_pricing_model',
  },
};
